import { createSlice } from '@reduxjs/toolkit'
import { initialState, listReducers } from './listConstants'

const auditTrailReportingSlice = createSlice({
    name: 'ui/audit-trail-reporting',
    initialState: {
        ...initialState
    },
    reducers: {
        ...listReducers
    }
})

export const auditTrailReportingActions = auditTrailReportingSlice.actions
export default auditTrailReportingSlice.reducer
